module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_flag.638c0bc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_flag.svg
// module id = 383
// module chunks = 0